import {TextToolTip} from "components";
import {EditActionBtn} from "components";
import {allStatusesList, Statuses} from "fragments";
import {Svg} from "assets";

export const employeeDetails = (item) => {
    return [
        {
            list: [
                {
                    title: "General Info",
                    list: [
                        {
                            title: "First Name",
                            desc: item?.firstName,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Last Name",
                            desc: item?.lastName,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "DOB",
                            desc: item?.dob,
                            dateRow: true,
                        },

                        {
                            title: "Position",
                            desc: item?.position,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Phone Number",
                            desc: item?.phone,
                            phoneRow: true,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Email",
                            desc: item?.email,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "SSN",
                            desc: item?.ssn,
                        },

                        {
                            title: "DI#",
                            desc: item?.dl,
                        },
                    ],
                },
            ],
        },
        {
            list: [
                {
                    title: "Address",
                    list: [
                        {
                            title: "Street",
                            desc: item?.address?.street,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Unit/Suit #",
                            desc: item?.address?.unitNumber,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "City",
                            desc: item?.address?.city,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "State",
                            desc: item?.address?.state,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Country",
                            desc: item?.address?.country,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Zip Code",
                            desc: item?.address?.zip,
                        },
                    ],
                },
            ],
        },
    ];
};

export const employeesHead = () => {
    return [
        {title: "Username", name: "username", searchKey: 'username', sortType: "username"},
        {title: "First Name", name: "firstName", searchKey: 'firstName', sortType: "firstName"},
        {title: "Last Name", name: "lastName", searchKey: 'lastName', sortType: "lastName"},
        {title: "Phone Number", name: "phone", searchKey: 'phone', sortType: "phoneNumber", custom: false},
        {title: "Email", name: "email", searchKey: 'email', sortType: "email", custom: false},
        {
            title: "Status",
            name: "status",
            disabled: true,
            filterList: [{name: "All", id: "All"}, ...allStatusesList],
            width: "149px"
        },
        {title: "Action", name: "action", noSearch: true, custom: false, width: "89px"},
    ];
};

export const employeesBody = ({handleDelete, handleEit}) => {
    return [
        {
            rowText: (item) => (
                <TextToolTip text={item?.username} content={item?.username}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.firstName} content={item?.firstName}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.lastName} content={item?.lastName}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.phone} content={item?.phoneNumber} phoneRow/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.email} content={item?.email}/>
            ),
        },

        {
            rowText: (item) => <Statuses status={item?.status}/>,
        },

        {
            rowText: (item) => (
                <div className="flex-all-center" style={{gap: 8}}>
                    <EditActionBtn onClick={() => handleEit(item)}/>
                    {/*<DeleteActionBtn onClick={() => handleDelete(item)} />*/}
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const emptyState = (addEmployee) => {
    return {
        emptyBtnText: 'Add Employee',
        notTitleText: 'No employees found',
        notDescText: 'Add your first employee to begin managing their information.',
        EmptySvg: Svg.EmptyFacility,
        clickToEmptyAddButton: () => addEmployee(),
    }
}
